export const createCollectionLightTheme = {
  '--create-collection-bgc-1': '#f8f8f8',
  '--create-collection-bgc-2': '#65d5ff',
  '--create-collection-bgc-3': '#f8f8f8',
  '--create-collection-bgc-4': 'linear-gradient(122deg, #238ec9 12%, #354acc 86%)',
  '--create-collection-font-c-1': '#333',
  '--create-collection-font-c-2': '#666',
  '--create-collection-font-c-3': '#f75b3d',
  '--create-collection-font-c-4': '#41CC8B',
  '--create-collection-font-c-5': '#65d5ff',
  '--create-collection-border-c-1': '#fff',
  '--create-collection-border-c-2': 'linear-gradient(341deg, #0989e5 9%, #36defd 83%)',
  '--create-collection-border-c-3': '#9fa7b3',
}
export const createCollectionDarkTheme = {
  '--create-collection-bgc-1': '#23262f',
  '--create-collection-bgc-2': '#65d5ff',
  '--create-collection-bgc-3': '#373b46',
  '--create-collection-bgc-4': 'linear-gradient(122deg, #238ec9 12%, #354acc 86%)',
  '--create-collection-font-c-1': '#fff',
  '--create-collection-font-c-2': '#9fa7b3',
  '--create-collection-font-c-3': '#f75b3d',
  '--create-collection-font-c-4': '#41CC8B',
  '--create-collection-font-c-5': '#65d5ff',
  '--create-collection-border-c-1': '#141417',
  '--create-collection-border-c-2': 'linear-gradient(341deg, #0989e5 9%, #36defd 83%)',
  '--create-collection-border-c-3': '#9fa7b3',
}
